const formateDate = (date) => new Date(date).toLocaleString('de-DE');

export default formateDate;
